import c851Image from "@images/calendar/85-1.jpg";
import c861Image from "@images/calendar/86-1.jpg";
import c871Image from "@images/calendar/87-1.jpg";
import c881Image from "@images/calendar/88-1.jpg";

import cikeImage from "@images/calendar/cike.jpg";
import xuanyuanImage from "@images/calendar/xuanyuanjian7.png";
import anyinghuojuImage from "@images/calendar/anyinghuoju.jpg";
import yingzhishiImage from "@images/calendar/yingzhishi.jpg";
import nixiangtantaImage from "@images/calendar/nixiangtanta.jpg";
import daojiImage from "@images/calendar/daoji.jpg";
import tangdourenImage from "@images/calendar/tangdouren.jpg";
import guanghuanImage from "@images/calendar/guanghuan.png";
import niluoheImage from "@images/calendar/niluohe.jpg";
import kanmengouImage from "@images/calendar/kanmengou.jpg";
import bianjingImage from "@images/calendar/bianjing.png";
import zhanyaoxingImage from "@images/calendar/zhanyaoxing.jpeg";
import qimakanshaImage from "@images/calendar/qimakansha.jpg";
import evoImage from "@images/calendar/EVOTINCTION.jpg";
import deepImage from "@images/calendar/DEEP.jpg";
import mingyun2Image from "@images/calendar/mingyun2.jpg";
import dibiaofazeImage from "@images/calendar/dibiaofaze.jpg";
import fengtuImage from "@images/calendar/fengtu.jpg";
import wuliImage from "@images/calendar/wuli2020.jpg";
import jujiImage from "@images/calendar/juji.jpeg";
import zhaoyaoxingjiluImage from "@images/calendar/zhaoyaoxingjilu.jpeg";
import ironharvestImage from "@images/calendar/ironharvest.jpg";
import madratdeadImage from "@images/calendar/madratdead.jpg";
import bianhuaImage from "@images/calendar/bianhua.png";

export const firstEventDate = "8.5";
export const firstEventTime = "20:00 开始";
// export const firstEventDate = "8.4";
// export const firstEventTime = "22:45 开始";
export const startDate = new Date("2020-08-05T20:00:00.000+08:00");

export const events = [
  {
    date: firstEventDate,
    color: "red",
    calendars: [
      {
        time: firstEventTime,
        label: "发布会",
        desc:
          "我们将以一场小型线上发布会作为整个活动的开始！在这场发布会上，将会有很多国内外独立游戏登场亮相，敬请期待～",
        right: c851Image,
        firstExpress: true
      }
    ]
  },
  {
    color: "aqua",
    date: "8.6",
    calendars: [
      {
        title: "刺客信条：英灵殿",
        time: "18:00 开始",
        label: "试玩录像解说",
        desc: "试玩嘉宾：Bin、Wing",
        right: cikeImage
      },
      {
        title: "轩辕剑柒",
        label: "试玩录像",
        right: xuanyuanImage
      },
      {
        title: "暗影火炬城",
        label: "实机试玩",
        desc: "试玩嘉宾：Nadya、小五",
        right: anyinghuojuImage
      },
      {
        title: "影之诗·巅峰对决",
        label: "实机演示",
        right: yingzhishiImage
      },
      {
        title: "逆向坍塌：面包房行动",
        label: "实机试玩",
        desc: "试玩嘉宾：Wing、无头",
        right: nixiangtantaImage
      },
      {
        title: "天穗种稻姬",
        label: "实机试玩",
        desc: "试玩嘉宾：Nadya、小五",
        right: daojiImage
      },
      {
        title: "糖豆人：终极淘汰赛",
        label: "欢乐试玩",
        desc: "试玩嘉宾：二七、小五",
        right: tangdourenImage
      },
      {
        title: "赛博朋克2077",
        label: ["独家视频", "访谈"],
        desc: "嘉宾：西蒙、四十二",
        right: c861Image,
        firstExpress: true
      }
    ]
  },
  {
    color: "yellow",
    date: "8.7",
    calendars: [
      {
        title: "光环：无限",
        time: "18:00 开始",
        label: "实机演示解说",
        right: guanghuanImage
      },
      {
        title: "尼罗河勇士",
        label: "实机试玩",
        desc: "试玩嘉宾：Bin、四十二",
        right: niluoheImage
      },
      {
        title: "看门狗：军团",
        label: "试玩录像解说",
        desc: "试玩嘉宾：Bin、四十二",
        right: kanmengouImage
      },
      {
        title: "边境",
        label: ["实机试玩录像", "访谈"],
        right: bianjingImage
      },
      {
        title: "斩妖行",
        label: "实机试玩",
        desc: "试玩嘉宾：Nadya、小五",
        right: zhanyaoxingImage
      },
      {
        title: "博德之门3",
        label: "实机试玩视频",
        desc: "Baldur's Gate III 独家实机试玩视频",
        right: c871Image,
        firstExpress: true
      },
      {
        title: "Othercide 彼岸花",
        label: ["实机试玩", "访谈"],
        desc: "试玩嘉宾：西蒙、四十二",
        right: bianhuaImage
      },
      {
        title: "骑马与砍杀2：霸主",
        label: ["制作人访谈录像"],
        desc: "连线嘉宾：CT",
        right: qimakanshaImage
      },
      {
        title: "斩妖行 纪录片",
        label: ["Gsense 纪录片"],
        right: zhaoyaoxingjiluImage
      }
    ]
  },
  {
    color: "blue",
    date: "8.8",
    calendars: [
      {
        title: "Splatoon2 夏季总决赛",
        time: "14:00 开始",
        label: ["游戏赛事", "虎牙独播"],
        desc: "spark 锦标赛 Splatoon2 项目夏季线上总决赛",
        right: c881Image,
        firstExpress: true
      },
      {
        title: "EVOTINCTION  演灭（暂定名）",
        label: "演示录像",
        right: evoImage
      },
      {
        title: "D.E.E.P - BATTLE OF JOVE",
        label: "实机试玩",
        desc: "试玩嘉宾：四十二、西蒙",
        right: deepImage
      },
      {
        title: "巨击大乱斗",
        label: "欢乐试玩",
        desc: "试玩嘉宾：Nadya、小五、二七、大巴",
        right: jujiImage
      },
      {
        title: "Mad Rat Dead",
        label: "实机试玩",
        desc: "试玩嘉宾：小五、Nadya",
        right: madratdeadImage
      },
      {
        title: "命运2",
        label: ["新资料片", "访谈"],
        right: mingyun2Image
      },
      {
        title: "地表法则：先遣者",
        label: "实机公开试玩",
        desc: "试玩嘉宾：大巴、四十二",
        right: dibiaofazeImage
      },
      {
        title: "Iron Harvest",
        label: "实机试玩",
        desc: "试玩嘉宾：西蒙、四十二",
        right: ironharvestImage
      },
      {
        title: "疯狂兔子：奇遇派对",
        label: "欢乐试玩",
        desc: "试玩嘉宾：Wing、囍字、二七、Nadya",
        right: fengtuImage
      },
      {
        title: "舞力全开2020 国行版",
        label: "欢乐试玩",
        desc: "试玩嘉宾：小五、二七、Hardy",
        right: wuliImage
      }
    ]
  }
];

export const twoDigit = num => (num >= 10 ? `${num}` : `0${num}`);

export const covertTimeToNum = s => Number(s.replace(":", ""));

export const dateValue = date => {
  return Number(`${twoDigit(date.getHours())}${twoDigit(date.getMinutes())}`);
};

export const timeValueArr = str => {
  if (str.indexOf("~") >= 0) {
    return str.split(" ~ ").map(s => covertTimeToNum(s));
  }
  const startTime = covertTimeToNum(str.replace(" 开始", ""));
  return [startTime, startTime + 300]; // 估计为3个小时
};

function getBeijingtime() {
  //获得当前运行环境时间
  const d = new Date();
  const currentDate = new Date();
  const tmpHours = currentDate.getHours();
  //算得时区
  let timeZone = -d.getTimezoneOffset() / 60;
  if (timeZone < 0) {
    timeZone = Math.abs(timeZone) + 8;
    currentDate.setHours(tmpHours + timeZone);
  } else {
    timeZone -= 8;
    currentDate.setHours(tmpHours - timeZone);
  }
  return currentDate;
}

const getCurrentDate = timeOffset => {
  const now = getBeijingtime();
  const time = now.getTime() + timeOffset;
  return new Date(time);
};

export const eventStatus = (event, calendar, timeOffset = 0) => {
  const year = 2020;
  const arr = event.date.split(".");
  const month = Number(arr[0]);
  const date = Number(arr[1]);
  const currentDate = getCurrentDate(timeOffset);
  let today = false;
  let now = false;

  if (
    currentDate.getFullYear() === year &&
    currentDate.getMonth() + 1 === month &&
    currentDate.getDate() === date
  ) {
    today = true;
    if (calendar && calendar.time) {
      const time = timeValueArr(calendar.time);
      const currentValue = dateValue(currentDate);
      if (currentValue >= time[0] && currentValue <= time[1]) {
        now = true;
      }
    }
  }

  return [today, now];
};

export const findCurrentEvent = timeOffset => {
  let found;
  events.forEach(event => {
    if (!event.calendars) {
      return;
    }
    event.calendars.forEach(c => {
      const [_, now] = eventStatus(event, c, timeOffset);
      if (now) {
        found = [event, c];
      }
    });
  });
  return found;
};
